jQuery(window).on("load", function () {

    /*if ($('.tab-content').length > 0) {
        $('body,html').animate({
            scrollTop: $('.tab-content').offset().top - 73
        }, 800);
    }*/


});

$(document).ready(function () {

    $("#menu").mmenu({
        "extensions": [
                "pagedim-black",
                "border-offset"
             ],
        classNames: {
            fixedElements: {
                fixed: "fix-menu"
            },
            vertical: "expand"
        }
    });

    $("#menu").mhead();

    var api = $('#menu').data('mmenu');
    api.bind("close:finish", function () {
        $('.ham').removeClass('active');
        $('.icon').removeClass('open');
    });

    /*$("nav .mm-listitem__text").click(
        function (evnt) {
            evnt.preventDefault();
            api.close();
        }
    )*/

    $('.services-block a').click(function () {
        localStorage.setItem("href", $(this).attr('href'));
    })

    if ($('.tab-content').length > 0) {

        var servHref = window.location.hash;

        for (var i = 0; i < $('.nav-link').length; i++) {

            if (servHref == $($('.nav-link')[i]).attr("href")) {
                $('.nav-link').removeClass('active');
                $($('.nav-link')[i]).addClass('active');
            } else if (servHref == "") {
                $($('.nav-link')[0]).addClass('active');
            }
            if (servHref.slice(1) == $($('.tab-pane')[i]).attr("id")) {
                $('.tab-pane').removeClass('show active');
                $($('.tab-pane')[i]).addClass('show active')
            } else if (servHref == "") {
                $($('.tab-pane')[0]).addClass('show active')
            }
        }

        $('.nav-link').click(function () {
            $('.nav-link').removeClass('active');
            $('.tab-pane').removeClass('show active');
            $(this).addClass('active');
            for (var i = 0; i < $('.nav-link').length; i++) {
                if ($(this).attr("href").slice(1) == $($('.tab-pane')[i]).attr("id")) {
                    $('.tab-pane').removeClass('show active');
                    $($('.tab-pane')[i]).addClass('show active')
                }
            }

            /*event.preventDefault();

            var id = $(this).attr('href'),

                top = $(id).offset().top - 80;

            $('body,html').animate({
                scrollTop: top
            }, 800);*/
            
            
        })
    }

    /*$('.nav-link').removeClass('active');
    $('.tab-pane').removeClass('show active')
    for (var i = 0; i < $('.nav-link').length; i++) {
        if (localStorage.getItem("href") == servHref) {
            $($('.nav-link')[i]).addClass('active');
        }

        if (localStorage.getItem("data-id") == $($('.tab-pane')[i]).attr("id")) {
            $($('.tab-pane')[i]).addClass('show active')
        }
    }*/

    /*if (localStorage.getItem("data-id") == '' || localStorage.getItem("data-id") == "undefined" || localStorage.getItem("data-id") == null) {
        $($('.nav-link')[1]).addClass('active');
        $($('.tab-pane')[1]).addClass('show active')
    }*/

    /*$('.nav-link').removeClass('active');
    $('.tab-pane').removeClass('show active')
    for (var i = 0; i < $('.nav-link').length; i++) {
        if (localStorage.getItem("data-id") == $($('.nav-link')[i]).attr('aria-controls')) {
            $($('.nav-link')[i]).addClass('active');
        }

        if (localStorage.getItem("data-id") == $($('.tab-pane')[i]).attr("id")) {
            $($('.tab-pane')[i]).addClass('show active')
        }
    }

    if (localStorage.getItem("data-id") == '' || localStorage.getItem("data-id") == "undefined" || localStorage.getItem("data-id") == null) {
        $($('.nav-link')[1]).addClass('active');
        $($('.tab-pane')[1]).addClass('show active')
    }*/

    /*$('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
            }
        });*/

    $(".services-block h2").on("click", function (event) {
        event.preventDefault();
        var anchor = $(this).find('a').attr('data-href');
        $('body,html').animate({
            scrollTop: $(anchor).offset().top
        }, 800);

    });

    $('a[data-toggle="tab"]').on('hide.bs.tab', function (e) {
        event.preventDefault();

        var id = $(this).attr('href'),
            top = $(id).offset().top - 73;

        $('body,html').animate({
            scrollTop: top
        }, 800);
    })

    if ($(window).width() < 1200) {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('.fix-menu').addClass('mh-scrolledout');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }

            lastScrollTop = st;
        });
    }

    /* var url = window.location.pathname.slice(6);
     $('.services-all').find('a').each(function () { // для каждой ссылки  
         var linkHref = $(this).attr('href'); //получаем href 
         if (url == linkHref) { //сравниваем полученное из адресной строки с href ссылки
             // при совпадении присваиваем класс
             $(this).find('.item').addClass('active');
         }
     });*/

    var location = window.location.href;
    var cur_url = location.split('/').pop();

    $('header nav ul li').each(function () {
        var link = $(this).find('a').attr('href');

        if (cur_url == link) {
            $(this).find('a').addClass('current');
        }
    });

    $('.lazy').lazy();

});
